module.exports = __webpack_public_path__ + "static/preview-leg-5b0c61bd0f6c7c3f44e99f36dbfd09c4.png";